import React from "react";

const ConfigSection = ({
  title,
  sectionKey,
  config,
  primaryFields,
  getFieldValue,
  expandedSections,
  toggleSection,
  borderColor,
  bgColor,
  bgColorHover,
  textColor,
  extraFilter,
  configSource,
}) => {
  const isExpanded = expandedSections[`${config.login}-${sectionKey}`];

  return (
    <div>
      <div className="flex justify-between items-center mb-3">
        <h5 className={`text-lg font-semibold text-white pb-2 border-b-2 ${borderColor}`}>
          {title}
        </h5>
        <button
          onClick={() => toggleSection(config.login, sectionKey)}
          className={`text-sm px-3 py-1 ${bgColor} hover:${bgColorHover} ${textColor} rounded transition`}
        >
          {isExpanded ? "کمتر" : "مشاهده بیشتر"}
        </button>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {primaryFields.map((field) => {
          const value = getFieldValue(config, field);
          if (value === undefined) return null;
          return (
            <div key={field} className="bg-gray-800 rounded-lg p-3">
              <span className="text-gray-400 text-xs block mb-1">
                {field.replace(/_/g, " ")}:
              </span>
              <p
                className={`font-medium text-sm ${
                  value === "true"
                    ? "text-green-400"
                    : value === "false"
                    ? "text-red-400"
                    : "text-white"
                }`}
              >
                {value}
              </p>
            </div>
          );
        })}
      </div>

      {isExpanded && (
        <div className="mt-3 pt-3 border-t border-gray-600">
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {Object.entries(config[configSource] || {})
              .filter(
                ([key]) =>
                  !primaryFields.includes(key) &&
                  (extraFilter ? extraFilter(key) : true)
              )
              .map(([key, value]) => (
                <div key={key} className="bg-gray-800 rounded-lg p-3">
                  <span className="text-gray-400 text-xs block mb-1">
                    {key}:
                  </span>
                  <p
                    className={`font-medium text-sm ${
                      value === "true"
                        ? "text-green-400"
                        : value === "false"
                        ? "text-red-400"
                        : "text-white"
                    }`}
                  >
                    {value}
                  </p>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ConfigSection;